import { Button, Spin } from "antd";
import BanIcon from "components/Icons/BanIcon";
import EditIcon from "components/Icons/EditIcon";
import { statusBadge } from "components/Table";
import { RouteName } from "constants/route";
import useAccountDetail from "hooks/accounts/useAccountDetail";
import { Link } from "react-router-dom";
import ActivateModal from "./components/ActivateModal";
import BanModal from "./components/BanModal";
import CheckIcon from "components/Icons/CheckIcon";
import { AiOutlineTransaction } from "react-icons/ai";
import ResetPasswordModal from "./components/ResetPasswordModal";
import KeyIcon from "components/Icons/KeyIcon";

export default function AccountDetail() {
  const {
    data: { loading, data },
    handleCloseActivate,
    handleCloseBan,
    handleOpenActivate,
    handleOpenBan,
    handleOpenReset,
    handleCloseReset,
    openActivate,
    openBan,
    openReset,
    fetchData,
  } = useAccountDetail();
  return (
    <div
      className="w-full bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      {loading ? (
        <div className="w-full flex items-center justify-center py-20">
          <Spin />
        </div>
      ) : (
        <div className="w-full">
          <h4 className="text-lg font-medium">Account Information</h4>
          <div className="w-full mt-6 flex flex-wrap">
            <div className="flex flex-col">
              <table className="text-sm">
                <tbody>
                  <tr className="mt-4">
                    <td className="font-semibold min-w-36">Full Name</td>
                    <td className="min-w-36">
                      {data?.first_name} {data?.last_name}
                    </td>
                  </tr>
                  <tr className="mt-4">
                    <td className="font-semibold min-w-36">Email</td>
                    <td className="min-w-36">{data?.email}</td>
                  </tr>
                  <tr className="mt-4">
                    <td className="font-semibold min-w-36">Role</td>
                    <td className="min-w-36">{data?.role.replace("_", " ")}</td>
                  </tr>
                  <tr className="mt-4">
                    <td className="font-semibold min-w-36">Phone Number</td>
                    <td className="min-w-36">{data?.phone}</td>
                  </tr>
                  <tr className="mt-4">
                    <td className="font-semibold min-w-36">Registered By</td>
                    <td className="min-w-36">
                      {data?.added_by
                        ? `${data.added_by.first_name} ${data.added_by.last_name}`
                        : "-"}
                    </td>
                  </tr>
                  <tr className="mt-4">
                    <td className="font-semibold min-w-36">Status</td>
                    <td className="min-w-36">
                      {statusBadge(data?.is_active ?? false)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-full flex items-center justify-start gap-x-4">
            <Link to={RouteName.EDIT_ACCOUNT.replace(":id", data!.id)}>
              <Button
                className="h-auto w-fit flex items-center px-6 py-2 gap-x-1 hover:text-black"
                type="primary"
              >
                <span className="text-sm inline-block">
                  <EditIcon />
                </span>
                <span>Edit</span>
              </Button>
            </Link>
            {data?.is_active ? (
              <Button
                onClick={handleOpenBan}
                className="h-auto w-fit flex items-center px-6 py-2 gap-x-1"
                type="primary"
                danger
              >
                <span className="text-sm inline-block">
                  <BanIcon />
                </span>
                <span>Ban</span>
              </Button>
            ) : (
              <Button
                onClick={handleOpenActivate}
                className="h-auto w-fit flex items-center px-6 py-2 gap-x-1 bg-success shadow-success shadow-sm hover:shadow-black"
                type="primary"
              >
                <span className="text-sm inline-block">
                  <CheckIcon />
                </span>
                <span>Activate</span>
              </Button>
            )}
            <Link to={RouteName.ACCOUNT_FINANCe.replace(":id", data!.id)}>
              <Button
                className="h-auto w-fit flex items-center px-6 py-2 gap-x-1 hover:text-black"
                type="primary"
              >
                <span className="text-sm inline-block">
                  <AiOutlineTransaction />
                </span>
                <span>Finance</span>
              </Button>
            </Link>
            <Button
              onClick={handleOpenReset}
              className="h-auto w-fit flex items-center px-6 py-2 gap-x-1 bg-yellow-600 hover:bg-yellow-700 text-white"
              type="primary"
            >
              <span className="text-sm inline-block">
                <KeyIcon />
              </span>
              <span>Reset Password</span>
            </Button>
          </div>
        </div>
      )}
      {data && (
        <>
          <ActivateModal
            account={data}
            handleClose={handleCloseActivate}
            open={openActivate}
            reload={fetchData}
          />
          <BanModal
            open={openBan}
            account={data}
            handleClose={handleCloseBan}
            reload={fetchData}
          />
          <ResetPasswordModal
            open={openReset}
            account={data}
            handleClose={handleCloseReset}
            reload={fetchData}
          />
        </>
      )}
    </div>
  );
}
